import { Menu } from '@univacity/angular/ui';
import { RoutePath } from '@univacity/shared/types';

export const mainMenu: Menu[] = [
  {
    text: $localize`Products`,
    subMenu: [
      {
        text: $localize`Programs`,
        link: RoutePath.programsSearch,
        description: $localize`Find programs to study from global institutes.`,
        icon: 'book',
        iconTheme: 'fill',
        iconStyle: { background: 'var(--sub-menu-programs-icon-bg)' },
      },
      {
        text: $localize`Payment`,
        link: RoutePath.payments,
        description: $localize`Pay your tuition fee in local currency.`,
        icon: 'credit-card',
        iconTheme: 'fill',
        iconStyle: { background: 'var(--sub-menu-tours-icon-bg)' },
      },
      {
        text: $localize`Tours`,
        link: RoutePath.tours,
        description: $localize`Find beautiful places to explore.`,
        icon: 'environment',
        iconTheme: 'fill',
        iconStyle: { background: 'var(--sub-menu-tours-icon-bg)' },
      },
      // {
      //   text: $localize`Institutes`,
      //   link: RoutePath.institutes,
      //   description: $localize`Find global institutes to study.`,
      //   icon: 'bank',
      //   iconTheme: 'fill',
      //   iconStyle: { background: 'var(--sub-menu-institutes-icon-bg)' },
      // },
      {
        text: $localize`Visa`,
        link: '/' + RoutePath.visa,
        description: $localize`Apply and get your visa immediately.`,
        icon: 'wallet',
        iconTheme: 'fill',
        iconStyle: { background: 'var(--sub-menu-institutes-icon-bg)' },
      },
    ],
  },
  {
    text: $localize`Solutions`,
    subMenu: [
      {
        text: $localize`For Students`,
        link: RoutePath.solutionsStudent,
        description: $localize`Find programs to study from global institutes.`,
      },
      {
        text: $localize`For Recruiters`,
        link: RoutePath.solutionsRecruiters,
        description: $localize`Find beautiful places to explore.`,
      },
      {
        text: $localize`For Institutes`,
        link: RoutePath.solutionsInstitutes,
        description: $localize`Find global institutes to study.`,
      },
    ],
  },
  // {
  //   text: $localize`Resources`,
  //   link: RoutePath.institutes,
  //   subMenu: [
  //     {
  //       text: $localize`Blog`,
  //       link: environment.externalLinks.blog,
  //       description: $localize`Find programs to study from global institutes.`,
  //     },
  //     {
  //       text: $localize`Help Center`,
  //       link: environment.externalLinks.helpDesk,
  //       description: $localize`Find beautiful places to explore.`,
  //     },
  //     {
  //       text: $localize`Careers`,
  //       link: environment.externalLinks.careers,
  //       description: $localize`Find global institutes to study.`,
  //     },
  //   ],
  // },
  // {
  //   text: $localize`Company`,
  //   link: RoutePath.institutes,
  //   subMenu: [
  //     {
  //       text: $localize`About ${environment.companyName}`,
  //       link: RoutePath.about,
  //       description: $localize`Find programs to study from global institutes.`,
  //     },
  //     {
  //       text: $localize`Contact Us`,
  //       link: RoutePath.contact,
  //       description: $localize`Find global institutes to study.`,
  //     },
  //   ],
  // },
];
